import { motion as m } from "framer-motion";

const ContactUs = () => {
  return (
    <m.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.75, ease: "easeOut" }}
    >
      <div className="flex justify-center px-4 pt-28 pb-20">
        <div className="w-full max-w-6xl rounded-lg bg-black p-6 text-center text-white">
          <h1 className="mb-4 text-[50px] font-bold">Contact Us</h1>

          <p className="mb-8">
            Have a question, comment, or concern? Get in touch with us.
          </p>

          <div className="space-y-4">
            <p>
              <span className="font-semibold">Email: </span>
              <a
                href="mailto:info@westmorebjj.com"
                className="text-[20px] font-bold underline hover:opacity-80"
              >
                info@westmorebjj.com
              </a>
            </p>

            <p>
              <span className="font-semibold">Phone: </span>
              <a
                href="tel:+18055551234"
                className="text-[20px] font-bold underline hover:opacity-80"
              >
                (805) 703-3249
              </a>
            </p>
          </div>
        </div>
      </div>
    </m.div>
  );
};

export default ContactUs;
